import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

const MARK_SOURCES = [64, 128, 256]

/** The clay Graphit emblem and wordmark, standalone (sign-in pages). */
export function GraphitBrand({ markSize = 44, className }) {
  const base = import.meta.env.BASE_URL.replace(/\/$/, '')
  return (
    <span className={cn('inline-flex items-center gap-3', className)}>
      <img
        src={`${base}/brand/graphit-mark-128.webp`}
        srcSet={MARK_SOURCES.map((px) => `${base}/brand/graphit-mark-${px}.webp ${px}w`).join(', ')}
        sizes={`${markSize}px`}
        width={markSize}
        height={markSize}
        alt=""
        draggable="false"
        className="shrink-0 select-none drop-shadow-[0_3px_5px_rgb(16_28_45/0.2)]"
        style={{ width: markSize, height: markSize }}
      />
      <span className="graphit-wordmark text-ink" style={{ fontSize: markSize * 0.62 }}>Graphit</span>
    </span>
  )
}

/**
 * The app's own identity at the top of the rail (Fluent 3D skin): the clay
 * Graphit emblem and wordmark. The organization moved to the title bar's
 * workspace switcher, so the rail no longer doubles as the tenant picker.
 *
 * @param {Object} props
 * @param {boolean} [props.collapsed=false] - Icons-only rail: the emblem alone
 */
export function GraphitPaneHeader({ collapsed = false }) {
  const base = import.meta.env.BASE_URL.replace(/\/$/, '')
  return (
    <Link
      to="/"
      aria-label="Graphit home"
      className={cn(
        'flex min-h-10 min-w-0 items-center gap-2.5 rounded-[6px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navigation-ink',
        collapsed ? 'w-11 justify-center' : 'w-full px-1.5'
      )}
    >
      <img
        src={`${base}/brand/graphit-mark-128.webp`}
        srcSet={MARK_SOURCES.map((px) => `${base}/brand/graphit-mark-${px}.webp ${px}w`).join(', ')}
        sizes="34px"
        width={34}
        height={34}
        alt=""
        draggable="false"
        className="size-[34px] shrink-0 select-none drop-shadow-[0_2px_3px_rgb(16_28_45/0.18)]"
      />
      {!collapsed && <span className="graphit-wordmark truncate text-navigation-ink">Graphit</span>}
    </Link>
  )
}
